module.exports = __webpack_public_path__ + "static/Local_Business-264c69a5cd15520a9d1a35b742cfaf92.mp4";